import gql from 'not-graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import {
  QueryValidatePersonArgs,
  ValidatePersonResponse,
} from '../__generated__/pge-types';

const VALIDATE_PERSON_QUERY = gql`
  query ValidatePerson($payload: ValidatePersonInput!) {
    validatePerson(payload: $payload) {
      isExistingPerson
      mainHasMultipleAccounts
      hasOnlineAccount
      username
      isBadDebt
      isFraud
      perId
      primaryIdType
      encryptedPersonId
    }
  }
`;

export const useValidatePersonQuery = () => {
  const { refetch, loading, error, data } = useQuery<
    { validatePerson: ValidatePersonResponse },
    QueryValidatePersonArgs
  >(VALIDATE_PERSON_QUERY, {
    skip: true,
  });
  return {
    refetch,
    loading,
    error,
    data,
  };
};

export default useValidatePersonQuery;
